import React, { useEffect } from 'react';
import { withAlert } from 'react-alert';
import { Button, Row, Col, Card } from 'antd';
import { compose } from 'redux';

function SubmitSuccessPage(props) {

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, []);

	return (
		<div
			style={{
				margin: 12,
				width: '100%',
				maxWidth: 800,
				backgroundColor: '#FFFFFF',
				padding: 12,
				borderRadius: 4,
				marginBottom: 400,
				textAlign: 'center',
				paddingTop: 40,
				paddingBottom: 100
			}}
		>
			<h1>Successfully submitted</h1>
			<Button
				onClick={() => props.redirectToWebForm()}
				style={{ background: '#003366', color: '#fff' }}
			>
                            Create another enquiry or feedback?
			</Button>
		</div>
	);
}

export default compose(
	withAlert()
)(SubmitSuccessPage);
